import { render, staticRenderFns } from "./View2.vue?vue&type=template&id=2f97a158"
import script from "./View2.vue?vue&type=script&lang=js"
export * from "./View2.vue?vue&type=script&lang=js"
import style0 from "./View2.vue?vue&type=style&index=0&id=2f97a158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports